import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.jsx';
import { DomainProvider } from './context/DomainContext.jsx';
import { BreadcrumbsCacheProvider } from './context/BreadcrumbsCacheContext.jsx';
import { HelmetProvider } from "react-helmet-async";
import { GoogleOAuthProvider } from '@react-oauth/google';

ReactDOM.createRoot(document.getElementById('root')).render(
  <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <DomainProvider>
            <BreadcrumbsCacheProvider>
              <App />
            </BreadcrumbsCacheProvider>
          </DomainProvider>
        </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  </GoogleOAuthProvider>
);